import { render, staticRenderFns } from "./PDFPreviewer.vue?vue&type=template&id=2d975332"
import script from "./PDFPreviewer.vue?vue&type=script&lang=js"
export * from "./PDFPreviewer.vue?vue&type=script&lang=js"
import style0 from "./PDFPreviewer.vue?vue&type=style&index=0&id=2d975332&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports